import type { RouteRecordRaw } from 'vue-router';
import DefaultBarView from '@views/Navigation/DefaultBarView.vue';
import DefaultRailView from '@views/Navigation/DefaultRailView.vue';
import DefaultBreadcrumbView from '@views/Navigation/DefaultBreadcrumbView.vue';
import ActionDetail from '@views/Action/ActionDetail.vue';

const usedPrefixes: string[] = [];

export default (prefix: string): RouteRecordRaw[] => {
    if (usedPrefixes.includes(prefix)) {
        throw new Error(`Action route prefix '${prefix}' is already in use`);
    }

    usedPrefixes.push(prefix);

    return [
        {
            path: 'action',
            name: `${prefix}ActionCreate`,
            components: {
                default: ActionDetail,
                bar: DefaultBarView,
                rail: DefaultRailView,
                breadcrumbs: DefaultBreadcrumbView,
            },
        },
        {
            path: ':actionType/:actionId',
            name: `${prefix}ActionDetail`,
            components: {
                default: ActionDetail,
                bar: DefaultBarView,
                rail: DefaultRailView,
                breadcrumbs: DefaultBreadcrumbView,
            },
        },
    ];
};
